import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, } from '@angular/forms';

import { MaterialsModule } from '@library/common/materials';
import { ErrorsModule } from '@library/modules/errors';

import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { CurrencySelectorComponent } from './currency-selector.component';

@NgModule({
  declarations: [
     CurrencySelectorComponent,
  ],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    MaterialsModule,
    ErrorsModule,
    NgxMatSelectSearchModule,
  ],
  exports: [
     CurrencySelectorComponent,
     NgxMatSelectSearchModule,
  ],
})
export class CurrencySelectorModule { }
